import type * as SchemaTypes from '../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchCurrentUserQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type FetchCurrentUserQuery = (
  { __typename: 'Query' }
  & { currentUser: (
    { __typename: 'CurrentUser' }
    & { user: (
      { __typename: 'SuperAdminUser' }
      & CurrentUser_SuperAdminUser_Fragment
    ) | (
      { __typename: 'TenantUser' }
      & CurrentUser_TenantUser_Fragment
    ), activeRole?: SchemaTypes.Maybe<(
      { __typename: 'RoleAssignment' }
      & RoleAssignmentFragment
    )> }
  ) }
);

export type CurrentUser_SuperAdminUser_Fragment = (
  { __typename: 'SuperAdminUser' }
  & Pick<SchemaTypes.SuperAdminUser, 'id' | 'email' | 'name' | 'isSuperAdmin' | 'firstName' | 'lastName' | 'has2FASetup'>
);

export type CurrentUser_TenantUser_Fragment = (
  { __typename: 'TenantUser' }
  & Pick<SchemaTypes.TenantUser, 'id' | 'email' | 'name' | 'isSuperAdmin' | 'firstName' | 'lastName' | 'has2FASetup'>
  & { company?: SchemaTypes.Maybe<(
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  )>, roleAssignments: Array<(
    { __typename: 'RoleAssignment' }
    & Pick<SchemaTypes.RoleAssignment, 'role'>
    & { assignedGroups?: SchemaTypes.Maybe<Array<(
      { __typename: 'AssignedGroup' }
      & Pick<SchemaTypes.AssignedGroup, 'groupId' | 'subGroupIds' | 'buddyIds'>
      & { group?: SchemaTypes.Maybe<(
        { __typename: 'Group' }
        & Pick<SchemaTypes.Group, 'id' | 'name'>
      )>, subGroups?: SchemaTypes.Maybe<Array<(
        { __typename: 'Subgroup' }
        & Pick<SchemaTypes.Subgroup, 'id' | 'name'>
      )>>, buddies?: SchemaTypes.Maybe<Array<(
        { __typename: 'TenantUser' }
        & Pick<SchemaTypes.TenantUser, 'id' | 'name'>
      )>> }
    )>> }
  )> }
);

export type CurrentUserFragment = CurrentUser_SuperAdminUser_Fragment | CurrentUser_TenantUser_Fragment;

export type RoleAssignmentFragment = (
  { __typename: 'RoleAssignment' }
  & Pick<SchemaTypes.RoleAssignment, 'role'>
  & { assignedGroups?: SchemaTypes.Maybe<Array<(
    { __typename: 'AssignedGroup' }
    & Pick<SchemaTypes.AssignedGroup, 'groupId' | 'subGroupIds' | 'buddyIds'>
    & { group?: SchemaTypes.Maybe<(
      { __typename: 'Group' }
      & Pick<SchemaTypes.Group, 'id' | 'name'>
    )>, subGroups?: SchemaTypes.Maybe<Array<(
      { __typename: 'Subgroup' }
      & Pick<SchemaTypes.Subgroup, 'id' | 'name'>
    )>>, buddies?: SchemaTypes.Maybe<Array<(
      { __typename: 'TenantUser' }
      & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'firstName' | 'lastName'>
    )>> }
  )>> }
);

export const CurrentUserFragmentDoc = /*#__PURE__*/ gql`
    fragment CurrentUser on BaseUser {
  id
  email
  name
  isSuperAdmin
  firstName
  lastName
  has2FASetup
  ... on TenantUser {
    __typename
    company {
      id
      name
    }
    roleAssignments {
      role
      assignedGroups {
        groupId
        group {
          id
          name
        }
        subGroupIds
        subGroups {
          id
          name
        }
        buddyIds
        buddies {
          ... on BaseUser {
            id
            name
          }
        }
      }
    }
  }
  ... on SuperAdminUser {
    __typename
  }
}
    `;
export const RoleAssignmentFragmentDoc = /*#__PURE__*/ gql`
    fragment RoleAssignment on RoleAssignment {
  role
  assignedGroups {
    groupId
    group {
      id
      name
    }
    subGroupIds
    subGroups {
      id
      name
    }
    buddyIds
    buddies {
      ... on BaseUser {
        id
        name
        firstName
        lastName
      }
    }
  }
}
    `;
export const FetchCurrentUserDocument = /*#__PURE__*/ gql`
    query FetchCurrentUser {
  currentUser {
    user {
      ... on BaseUser {
        ...CurrentUser
      }
    }
    activeRole {
      ... on RoleAssignment {
        ...RoleAssignment
      }
    }
  }
}
    ${CurrentUserFragmentDoc}
${RoleAssignmentFragmentDoc}`;

/**
 * __useFetchCurrentUserQuery__
 *
 * To run a query within a React component, call `useFetchCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>(FetchCurrentUserDocument, options);
      }
export function useFetchCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>(FetchCurrentUserDocument, options);
        }
// @ts-ignore
export function useFetchCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>;
export function useFetchCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<FetchCurrentUserQuery | undefined, FetchCurrentUserQueryVariables>;
export function useFetchCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>(FetchCurrentUserDocument, options);
        }
export type FetchCurrentUserQueryHookResult = ReturnType<typeof useFetchCurrentUserQuery>;
export type FetchCurrentUserLazyQueryHookResult = ReturnType<typeof useFetchCurrentUserLazyQuery>;
export type FetchCurrentUserSuspenseQueryHookResult = ReturnType<typeof useFetchCurrentUserSuspenseQuery>;
export type FetchCurrentUserQueryResult = Apollo.QueryResult<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>;